import VModal from '@/vuetify_custom/v-modal_v1'
import VForm from '@/vuetify_custom/v-form'
import {postTreeSaveApi} from './service'
import {mapGetters} from "vuex";
export default {
    data() {
        return {
            show:false,
            loading:false,
            params: {
                id: '',
                customer_function_id: ''
            },
           
        }
    },
    computed: {
        ...mapGetters('async', [
            'customer_functions'
          ]),
        fields() {
            return [
                {
                    label: '职能',
                    type: 'autocompletes',
                    key:'customer_function_id',
                    items: this.customer_functions,
                    'item-value':'id',
                    'item-text':'name',
                    cols:12,
                    clearable: true,
                    // required: true,
                    // rules:[val => !!val || '必选']
                },
             
            ]
        }
    },
    methods: {
        edit(data) {
            this.show = true
            this.params.id = data.id
            this.params.customer_function_id = data.customer_function_id
        },
        submit() {
            if (this.$refs.form.validate()) {
                this.loading = true
                postTreeSaveApi(this.params).then(() => {
                    this.$emit('success')
                    this.$Message.success('数据保存成功！')
                    this.show = false
                }).finally(() => {
                    this.loading = false
                })
            }
        }
    },
    render() {
     
        return <VModal
        v-model={this.show}
        dynamicHeight
        heightRate={0.5}
        title="职能"
        loading={this.loading}
        width={500}
        ref="modal"
        ok-text="保存"
        on={{
            ok: () => {
                this.submit() 
            },
        }}
        >
            <VForm 
                ref="form" 
                fields={this.fields} 
                v-model={this.params}
            />
        </VModal>
    }
}